/** Affichage salarié des ayants droit (lecture seule, partagé entre modules). */

export const BENEFICIARY_RELATION_VALUES = [
  'spouse',
  'child',
  'parent',
  'cohabitant',
  'pacs',
  'sibling',
  'friend',
  'colleague',
  'other',
] as const

export type BeneficiaryRelation = (typeof BENEFICIARY_RELATION_VALUES)[number]

export const BENEFICIARY_RELATION_I18N_KEYS = {
  spouse: 'profile.beneficiary.relation_conjoint',
  child: 'profile.beneficiary.relation_enfant',
  parent: 'profile.beneficiary.relation_parent',
  cohabitant: 'profile.beneficiary.relation_cohabitant',
  pacs: 'profile.beneficiary.relation_pacs',
  sibling: 'profile.beneficiary.relation_sibling',
  friend: 'profile.beneficiary.relation_friend',
  colleague: 'profile.beneficiary.relation_colleague',
  other: 'profile.beneficiary.relation_autre',
} as const satisfies Record<BeneficiaryRelation, string>

export type BeneficiaryOption = {
  id: string
  nom: string
  prenom: string
  date_naissance?: string | null
  relation: string
  relation_other?: string | null
}

export function beneficiaryRelationLabel(t: (key: string) => string, relation: string): string {
  if (!(BENEFICIARY_RELATION_VALUES as readonly string[]).includes(relation)) {
    return relation
  }
  return t(BENEFICIARY_RELATION_I18N_KEYS[relation as BeneficiaryRelation])
}
